import React, { PureComponent } from 'react'
import { Grid, Button } from '@material-ui/core'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'

class ThankYou extends PureComponent {
  goToLogin = () => {
    this.props.history.push('/login')
  }

  render() {
    const { firstname = '' } = this.props.location.state || {}
    console.log(this.props)
    return (
      <Grid className="rightBlockLogin thanks-component" item xs={11} sm={7} md={11} lg={7}>
        <div>
          <h1 className="big-header slim-heading">Thanks {firstname}!</h1>
          <p>Your account is all set up. Please log in using the link below.</p>
        </div>
        <Grid container className="margin-bottom-medium">
          <div className="full-width margin-top-small">
            <Button id="login-button" onClick={this.goToLogin}>
              Login
            </Button>
          </div>
        </Grid>
        <hr className="margin-top-medium margin-bottom-medium" />
        <Grid container className="margin-top-small">
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p>
              BLAZE Retail is available on
              <br />
              both iPhone and iPad apps.
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Button className="float-right download-our-app" id="login-button">
              <a href="https://itunes.apple.com/us/app/blaze-retail-point-of-sale/id1141933462?mt=8">
                Download our App
              </a>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

const ContainerWithCustomTitle = (props) => {
  const SideHOC = SideCoverHOC(ContainerWithTitle(ThankYou, 'Thank You'))
  return <SideHOC heading="Thank You!" {...props} />
}

export default ContainerWithCustomTitle



// WEBPACK FOOTER //
// ./src/containers/ThankYou.js